import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { ReactNode } from 'react';

import { DashboardContentLayout } from '~ui-components/components/atoms/dashboard-content-layout';

interface DataImportProps {
	slots: {
		SideNav: ReactNode;
		Content: ReactNode;
	};
}

export function DataImport({ slots: Slots }: DataImportProps) {
	return (
		<DashboardContentLayout pageTitle="Import Data">
			<Stack
				direction={{ xs: 'column', md: 'row' }}
				spacing={4}
				sx={{ position: 'relative' }}
			>
				{Slots.SideNav}
				<Box sx={{ flex: '1 1 auto', minWidth: 0 }}>{Slots.Content}</Box>
			</Stack>
		</DashboardContentLayout>
	);
}
